// extracted by mini-css-extract-plugin
module.exports = {"scrollableContent":"website-stat_scrollableContent_3bujy","message":"website-stat_message_1s_jV","notScrollableContent":"website-stat_notScrollableContent_QvYEx"};